/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        //Search functionality
        jQuery('#search-nodata').hideseek({
          nodata: 'No results found',
          highlight: true
        });

        // JavaScript to be fired on all pages
        $('.search-field').after('<i class="fa fa-search" aria-hidden="true"></i>');
        //Gallery
        /* ---------------------------------
                   MOBILE MENU
        --------------------------------- */
        $(function () {
          $('#menu-product-navigation-1').slicknav({
            appendTo: '.banner',
            label: 'SHOP FINISHES'
          });
        });
        /* ---------------------------------
                   MOBILE MENU END
        --------------------------------- *
        /* ---------------------------------
                MEGA MENU START
        --------------------------------- */
        //Enable the trigger by adding a class
        $('.menu-shop-finishes').addClass('product-menu-trigger');
        //open/close mega-navigation
        $('.product-menu-trigger').on('click', function (event) {
          event.preventDefault();
          $('.nav-product .menu-all-products > ul').show();
        });
        //Product Menu
        $('.slimmenu').slimmenu({
          resizeWidth: '991',
          collapserTitle: 'Shop Online',
          animSpeed: 'fast',
          indentChildren: true,
          childrenIndenter: '&raquo;',
          expandIcon: '<i class="fa fa-caret-right"></i>'
        });
        $('li.has-submenu > a').on('click', function (e) {
          e.preventDefault();
        });
        /* ---------------------------------
                   MEGA MENU END
        --------------------------------- */
        /* ---------------------------------
                 WOOCOMMERCE START
        --------------------------------- */
        //select class added
        $('select.addon-select').closest('div.product-addon').addClass('addon-select-wrap');
        //radio class added
        $('input.addon-radio').closest('div.product-addon').addClass('addon-radio-wrap');
        $('.addon-radio-wrap label').on('click', function () {
          var radioWrap = $(this).closest('div.product-addon');
          $(radioWrap).find('label').removeClass('active');
          $(this).addClass('active');
        });

        //nav arrows
        $('.page-numbers li a.prev').text('').append('<i class="fa fa-caret-left"></i>');
        $('.page-numbers li a.next').text('').append('<i class="fa fa-caret-right"></i>');

        //Show Calculator
        $('#show-cal').on('click', function () {
          $(this).toggleClass('active');
          if ($(this).hasClass('active')) {
            $('.form').fadeIn('fast');
            $(this).find('span').text('-');
          } else {
            $('.form').fadeOut('fast');
            $(this).find('span').text('+');
          }
        });
        //Calculate
        $('.width, .length').on('keyup', function () {
          // 1 square foot = 0.09290304 square metres
          if ($('.width').val() && $('.length').val()) {
            var total = $('.total');
            var coverage = (parseFloat($(".coverage").val(), 10) * 10.7639);
            var width = parseFloat($(".width").val(), 10);
            var length = parseFloat($(".length").val(), 10);
            var squareft = width * length;
            var finalTotal = squareft / coverage;
            /*console.log(coverage);
            console.log(width);
            console.log(length);
            console.log(squareft);*/
            var ml = 0;
            var metric = ' Litre(s)';
            if ((finalTotal > 0) && (finalTotal < 1)) {
              ml = finalTotal * 1000;
              metric = ' ml';
            } else {
              ml = finalTotal;
            }
            var valueFormatted = '';
            valueFormatted = ml.toFixed(0);
            if (isNaN(valueFormatted)) {
              valueFormatted = 0;
            } else {
              valueFormatted = ml.toFixed(0);
            }
            if (metric === ' Litre(s)' && ml % 1 !== 0) {
              valueFormatted = ml.toFixed(1);
            }
            valueFormatted = valueFormatted + ' ' + metric;
            $(total).text(valueFormatted);
          }
        });

        // STAR FUNCTIONALITY
        $('.stars span a').on('click', function () {
          $('.stars span a').removeClass('highlighted');
        });
        $('.star-2').on('click', function () {
          $('.star-1').addClass('highlighted');
        });
        $('.star-3').on('click', function () {
          $('.star-1').addClass('highlighted');
          $('.star-2').addClass('highlighted');
        });
        $('.star-4').on('click', function () {
          $('.star-1').addClass('highlighted');
          $('.star-2').addClass('highlighted');
          $('.star-3').addClass('highlighted');
        });
        $('.star-5').on('click', function () {
          $('.star-1').addClass('highlighted');
          $('.star-2').addClass('highlighted');
          $('.star-3').addClass('highlighted');
          $('.star-4').addClass('highlighted');
        });

        $('.variations .value div label').on('click', function () {
          var label = $(this);
          var otherLabels = $(label).parent().siblings().find('label');
          $(otherLabels).removeClass('active');
          $(label).addClass('active');
        });

        $('a.reset_variations').on('click', function () {
          $('.variations .value div label').removeClass('active');
        });


        /* Cmment form */
        var validator = $("#commentform").validate({
          ignore: [],
          rules: {
            hiddenRecaptcha: {
              required: function () {
                if (grecaptcha.getResponse() === '') {
                  return true;
                } else {
                  return false;
                }
              }
            }
          },
          messages: {
            hiddenRecaptcha: "<p>Please complete human verification.</p>"
          }
        });
        $(".single_variation_wrap").on("show_variation", function (event, variation) {
          // Fired when the user selects all the required dropdowns / attributes
          // and a final variation is selected / shown
          $('.single_variation_wrap .woocommerce-variation').hide();
          setTimeout(function () {
            var totalPrice = $('.woocommerce-variation-price span.woocommerce-Price-amount').html();
            //console.log(totalPrice);
            $('p.price').html(totalPrice);
          }, 50); // Timeout function set for a slight delay in reading the changed price

        });
        /* ---------------------------------
                 WOOCOMMERCE END
        --------------------------------- */
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
        $(window).load(function () {
          $('#homeSlider').flexslider({
            animation: "fade"
          });
        });

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Documents
    'documents': {
      init: function () {
        // JavaScript to be fired on the home page

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Delivery
    'delivery_returns': {
      init: function () {
        // JavaScript to be fired on the home page
        $('#tableOverValues .select-area select').on('change', function () {
          var tablePabel = $('#tableOverValues #tablePanel');
          var contactPabel = $('#tableOverValues #contactPanel');
          $('#tableOverValues .delivery-tab').removeClass('active');
          var value = $(this).val();
          $('#tableOverValues ' + value).addClass('active');
          //console.log('#tableOverValues ' + value);
        });
        $('#tableUnderValues .select-area select').on('change', function () {
          var tablePabel = $('#tableUnderValues #tablePanel');
          var contactPabel = $('#tableUnderValues #contactPanel');
          $('#tableUnderValues .delivery-tab').removeClass('active');
          var value = $(this).val();
          $('#tableUnderValues ' + value).addClass('active');
          //console.log('#tableOverValues ' + value);
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'video_guides': {
      init: function () {
        // JavaScript to be fired on the about us page

      }
    },
    'company': {
      init: function () {
        // JavaScript to be fired on the about us page
        $('.popupLinks').magnificPopup({
          delegate: 'a',
          type: 'image',
          closeOnContentClick: false,
          closeBtnInside: false,
          mainClass: 'mfp-with-zoom mfp-img-mobile',
          image: {
            verticalFit: true,
            titleSrc: function (item) {
              return item.el.attr('title') + '';
            }
          },
          zoom: {
            enabled: true,
            duration: 300, // don't foget to change the duration also in CSS
            opener: function (element) {
              return element.find('img');
            }
          }
        });
      }
    },
    'inspiration': {
      init: function () {
        // JavaScript to be fired on the Inspiration page
        // Gallery
        $('.inspiration-gallery').magnificPopup({
          delegate: 'a',
          type: 'image',
          closeOnContentClick: false,
          closeBtnInside: false,
          mainClass: 'mfp-with-zoom mfp-img-mobile',
          image: {
            verticalFit: true,
            titleSrc: function (item) {
              return item.el.attr('title') + '';
            }
          },
          gallery: {
            enabled: true
          },
          zoom: {
            enabled: true,
            duration: 300, // don't foget to change the duration also in CSS
            opener: function (element) {
              return element.find('img');
            }
          }
        });
      }
    },
    'cart': {
      init: function () {
        // JavaScript to be fired on the Inspiration page
        $('.tax-total th').html('Sales Tax');
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
